import { SeasonDTO } from "../dtos/SeasonDTO";
import { Mode, Status } from "../lib/globalEnums";
import { useEffect, useState } from "react";
import Spinner from "./Spinner";
import WeekendTeaser from "./WeekendTeaser";

export default function Season(props: {
  year: number | string,
  currentWeekend?: string,
  mode?: Mode
}) {
  const { year, currentWeekend } = props
  const [season] = useState(new SeasonDTO({year: year as number}))
  const [status, setStatus] = useState(Status.loading)
  useEffect(() => {
    setStatus(Status.loading)
    season.load(year as number).then(() => setStatus(Status.ready))
  }, [year, season])
  if (status === Status.loading) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  const className = 'w3-margin-bottom ' + (props.mode === Mode.extended ? 'flex-wrap flex-gap' : 'flex-column h100 scroll')
  return (
    <div className={className}>
      {season.getWeekends().map(weekend =>
        <WeekendTeaser
          key={`season-weekend-${weekend.meeting_key}`}
          weekend={weekend}
          active={weekend.circuit_short_name === currentWeekend}
          mode={props.mode}
        />
      )}
    </div>
  );
}